import React from "react";

/** תנאי שימוש — עברית (עדכון אחרון: 17 באפריל 2026) */
const TermsHebrewBody: React.FC = () => (
  <>
    <p className="text-body leading-relaxed mb-6">
      ברוכים הבאים ל־MySipur (&quot;הפלטפורמה&quot;, &quot;אנחנו&quot;, &quot;שלנו&quot;). בשימוש בפלטפורמה זו, אתה מסכים לתנאי שימוש
      אלה.
    </p>
    <p className="text-body leading-relaxed mb-8">אם אינך מסכים, אין להשתמש בפלטפורמה.</p>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">1. זכאות לשימוש</h2>
      <p className="text-body leading-relaxed">
        עליך להיות בן 18 ומעלה כדי להשתמש בפלטפורמה. בשימוש בפלטפורמה, אתה מאשר כי אתה עומד בדרישה זו.
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">2. תיאור השירות</h2>
      <p className="text-body leading-relaxed">
        MySipur מספקת שירות המאפשר למשתמשים ליצור ספרי ילדים דיגיטליים מותאמים אישית, באמצעות תוכן שהמשתמש מספק, כולל
        טקסטים ותמונות, המעובדים באמצעות כלי בינה מלאכותית. השירות ניתן כעת ללא תשלום.
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">3. אחריות המשתמש על תוכן</h2>
      <p className="text-body leading-relaxed mb-3">אתה אחראי באופן מלא לכל תוכן שאתה מעלה, כולל:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed mb-3">
        <li>תמונות</li>
        <li>טקסט</li>
        <li>מידע אישי</li>
      </ul>
      <p className="text-body leading-relaxed mb-3">בהעלאת תוכן, אתה מצהיר ומתחייב כי:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>אתה בעל הזכויות בתוכן או שיש לך הרשאה חוקית להשתמש בו</li>
        <li>קיבלת אישור מכל אדם המופיע בתמונות</li>
        <li>במקרה של קטינים, אתה האפוטרופוס החוקי או שיש לך אישור מפורש מהאפוטרופוס</li>
        <li>התוכן אינו מפר חוק, פרטיות או זכויות קניין רוחני</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">4. שימוש בבינה מלאכותית</h2>
      <p className="text-body leading-relaxed mb-3">בשימוש בפלטפורמה, אתה מאשר כי:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>התוכן שאתה מעלה עשוי להישלח לעיבוד אצל ספקי AI צד שלישי (כולל OpenAI)</li>
        <li>העיבוד נחוץ לצורך יצירת התוכן המבוקש</li>
        <li>אנו לא משתמשים בתוכן שלך לאימון מודלים</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">5. אחסון ומחיקת מידע</h2>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>התוכן נשמר באופן זמני באמצעות Cloudflare R2</li>
        <li>התוכן נמחק לאחר השלמת יצירת הספר</li>
        <li>אין התחייבות לשחזור מידע לאחר מחיקה</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">6. שימוש אישי בלבד</h2>
      <p className="text-body leading-relaxed mb-3">הפלטפורמה מיועדת לשימוש אישי ולא מסחרי בלבד. אין:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>למכור או להפיץ את התוצרים</li>
        <li>להשתמש בפלטפורמה למטרות עסקיות ללא אישור</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">7. תוכן אסור</h2>
      <p className="text-body leading-relaxed mb-3">אין להעלות תוכן אשר:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed mb-3">
        <li>מפר חוק</li>
        <li>פוגע בזכויות צד שלישי</li>
        <li>פוגעני או לא ראוי</li>
        <li>כולל תמונות ללא אישור</li>
      </ul>
      <p className="text-body leading-relaxed">אנו שומרים לעצמנו את הזכות להסיר כל תוכן לפי שיקול דעתנו.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">8. היעדר אחריות</h2>
      <p className="text-body leading-relaxed mb-3">הפלטפורמה ניתנת &quot;כפי שהיא&quot; (AS IS). אין התחייבות ל:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed mb-3">
        <li>דיוק</li>
        <li>איכות</li>
        <li>עקביות</li>
        <li>התאמה למטרה מסוימת</li>
      </ul>
      <p className="text-body leading-relaxed">תוכן שנוצר באמצעות AI עשוי להכיל טעויות.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">9. הגבלת אחריות</h2>
      <p className="text-body leading-relaxed mb-3">במידה המקסימלית המותרת לפי חוק:</p>
      <p className="text-body leading-relaxed mb-3">MySipur לא תהיה אחראית ל:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed mb-3">
        <li>נזקים הנובעים משימוש בפלטפורמה</li>
        <li>בעיות הקשורות לתוכן שהמשתמש העלה</li>
        <li>הסתמכות על התוכן שנוצר</li>
      </ul>
      <p className="text-body leading-relaxed">השימוש הוא על אחריות המשתמש בלבד.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">10. זכות לסירוב או הסרה</h2>
      <p className="text-body leading-relaxed mb-3">אנו רשאים:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed mb-3">
        <li>לסרב לספק שירות</li>
        <li>להסיר תוכן</li>
        <li>להגביל גישה</li>
      </ul>
      <p className="text-body leading-relaxed">לפי שיקול דעתנו וללא הודעה מוקדמת.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">11. קניין רוחני</h2>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>אתה שומר על הבעלות על התוכן שהעלית</li>
        <li>אנו לא טוענים לבעלות על התוכן</li>
        <li>אנו לא משתמשים בתוכן לצרכים שיווקיים</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">12. שינויים בשירות</h2>
      <p className="text-body leading-relaxed mb-3">אנו רשאים:</p>
      <ul className="list-disc ps-6 space-y-1 text-body leading-relaxed">
        <li>לשנות או להפסיק את השירות</li>
        <li>לשנות פונקציונליות</li>
      </ul>
      <p className="text-body leading-relaxed mt-3">בכל עת וללא הודעה.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">13. דין חל</h2>
      <p className="text-body leading-relaxed">תנאים אלה כפופים לדיני מדינת פלורידה, ארצות הברית.</p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">14. שימוש בינלאומי</h2>
      <p className="text-body leading-relaxed">
        משתמשים מחוץ לארה״ב משתמשים בפלטפורמה על אחריותם ועליהם לעמוד בחוקי מדינתם.
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-bold text-heading mb-2">15. יצירת קשר</h2>
      <p className="text-body leading-relaxed">
        <a
          className="font-semibold text-brandNavy underline underline-offset-2 hover:text-brandOrange focus:outline-none focus:ring-2 focus:ring-brandOrange rounded"
          href="mailto:support@mysipur.app"
        >
          support@mysipur.app
        </a>
      </p>
    </section>
  </>
);

export default TermsHebrewBody;
